import { render, staticRenderFns } from "./right.vue?vue&type=template&id=556ded5d&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=556ded5d&prod&lang=css"
import style1 from "./right.vue?vue&type=style&index=1&id=556ded5d&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ded5d",
  null
  
)

export default component.exports